<div id="map">
  <div leaflet [leafletOptions]="mapOptions" (leafletMapReady)="onMapReady($event)"></div>
</div>
